import React from "react";
import HealthCardAlert from "./healthCardAlert/HealthCardAlert";
import HealthCardCopy from "./healthCardCopy/HealthCardCopy";

import "./healthCardNotActive.css";

const HealthCardNotActive = () => {
	return (
		<div className="health-card-container">
			<div className="health-card-alert">
				<HealthCardAlert />
			</div>
			<div className="health-card-copy">
				<HealthCardCopy />
			</div>
		</div>
	);
};

export default HealthCardNotActive;
